<template>
  <div class="drawer" v-if="electorateName" :class="{ closed: !openDrawer }">
    <div class="top" :class="{ hide: !openDrawer }">
      <i class="fa fa-angle-right" @click="handleDrawer(false)"></i>
    </div>
    <div
      class="top closed"
      :class="{ hide: openDrawer }"
      @click="handleDrawer(true)"
    >
      <i class="fa fa-angle-left"></i>
    </div>

    <div class="wrapper" :class="{ hide: !openDrawer }">
      <div class="title">
        <h4>{{ electorateName }}</h4>
      </div>
      <div class="content">
        <div class="details">
          <img
            :src="speciesData.picture.fields.file.url"
            alt="species image"
            style="object-fit: cover; max-height: 150px"
          />
          <p class="description" style="max-height: 150px">
            {{ speciesData.fact }}
          </p>
        </div>
        <button type="button" @click="learnMore">Learn more</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Drawer",
  computed: {
    ...mapGetters(["electorateName", "openDrawer", "speciesData"]),
  },
  methods: {
    handleDrawer(close) {
      this.$store.commit("updateOpenDrawer", close);
    },
    learnMore() {
      document.getElementsByClassName("mby-species-details")[0].scrollIntoView({
        behavior: "smooth",
      });
      
      // Log learn more
      this.$store.dispatch("logSimpleEvent", {
        eventName: "Learn More (Species Electorate Panel)",
        eventProperties: { "Click": this.speciesData.commonName },
      });
    },
  },
};
</script>

<style scoped>
.drawer {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 300px;
  height: 450px;
  padding: 24px;
  background-color: #fff;
}

.closed {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 70px;
  height: 45px;
  padding: 0;
}

.hide {
  display: none;
}

.top {
  z-index: 10;
}

.top.closed {
  display: flex;
  justify-content: flex-start;
  padding-left: 12px;
  cursor: pointer;
}

i {
  color: var(--black);
  cursor: pointer;
}

.wrapper {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
  top: -20px;
  height: 100%;
  background-color: #fff;
}

.title {
  display: flex;
  justify-content: center;
}

h4 {
  /* width: ; */
  margin: 0;
  color: var(--black);
}

.content {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  height: 100%;
}

.details {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

p {
  color: var(--black);
  overflow-y: auto;
}

.image {
  width: 100%;
  height: 150px;
  border: 1px solid #dadada;
  border-radius: 4px;
  background-color: #eff3fd;
}

button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 0;
  font-family: var(--font-secondary);
  font-size: 1.5em;
  color: #fff;
  border-radius: var(--border-radius);
  background-color: var(--black);
  cursor: pointer;
  text-transform: uppercase;
  padding: 24px;
  margin: 0;
}

@media screen and (max-width: 400px) {
  .drawer {
    top: 10%;
    width: 95%;
    height: 390px;
  }

  .closed {
    width: 70px;
    height: 45px;
  }
}


/* Style from elcom */
h4 {
  font-family: 'Lato',sans-serif;
  font-weight: 600;
  font-size: 26;
}
/* END */
</style>


// WEBPACK FOOTER //
// Drawer.vue?3d3f8cca